import { Page } from '@cincoders/cinnamon';
import Keycloak from 'keycloak-js';
import { useCallback } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { listSystems } from '../../utils/systemsList';
import logoCin from '../../assets/icons/cin-logo.svg';
import { sideMenuLinks } from '../SideMenuLinks';

interface PageProps {
  children: JSX.Element | JSX.Element[];
  keycloak?: Keycloak;
}

export default function PageCin({ children, keycloak }: PageProps): JSX.Element {
  const RecentActorsIconComponent = useCallback(
    () => <DashboardIcon sx={{ display: 'center', marginLeft: '2rem' }} fontSize='large' htmlColor='#DB1E2F' />,
    [],
  );

  return (
    <Page
      navbar={{
        title: 'Dashboard Sipac',
        sideMenuLinks,
        keycloakInstance: keycloak,
        logoSrc: logoCin,
        accountManagementUrl: 'https://account.cin.ufpe.br',
        logoRedirectUrl: 'https://intranet.cin.ufpe.br/',
        systemsList: listSystems,
        IconComponent: RecentActorsIconComponent,
      }}
      footer={{
        title: 'SUPORTE TÉCNICO',
        telephone: '(81) 2126-8430',
        telephoneComplement: 'Ramal: 4017 / 4748',
        email: 'helpdesk@cin.ufpe.br',
        link: 'https://helpdesk.cin.ufpe.br',
        textLink: 'Site',
        description: 'Helpdesk - Gerência de Sistemas \n Sala B011',
        copyrightText: 'CIn UFPE | Todos os direitos reservados',
      }}
      centralized
      haveToast
      createNavbarContext
    >
      {children}
    </Page>
  );
}
